<template>
	<div class="field__group">
		<label :for="_uid" class="hidden">{{ label + ((required)?'*':'') }}</label>
		<textarea :class="{error: errors && errors.length > 0}" :name="_uid" :id="_uid" :placeholder="label + ((required)?'*':'')" v-model="text" :cols="cols" :rows="rows"></textarea>
		<input-errors :errors="errors"></input-errors>
	</div>
</template>

<script>
	export default {
		props: ['value', 'label', 'required', 'errors', 'cols', 'rows'],
		data() {
			return {
				text: this.value
			};
		},
		watch: {
			text() {
				this.$emit('input', this.text);
			},
			value() {
				this.text = this.value;
			}
		}
	}
</script>